export const asClipBoard = {
  data: `<svg width="14" height="15" viewBox="0 0 14 15" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.0001 0.166016H2.0003C1.26698 0.166016 0.666992 0.766016 0.666992 1.49935V10.8327H2.0003V1.49935H10.0001V0.166016ZM12.0001 2.83268H4.66691C3.93359 2.83268 3.3336 3.43268 3.3336 4.16602V13.4993C3.3336 14.2327 3.93359 14.8327 4.66691 14.8327H12.0001C12.7334 14.8327 13.3334 14.2327 13.3334 13.4993V4.16602C13.3334 3.43268 12.7334 2.83268 12.0001 2.83268ZM12.0001 13.4993H4.66691V4.16602H12.0001V13.4993Z" />
  </svg>
  `,
  name: 'clipBoard',
};
